<script lang="ts">
    import {getContext} from "svelte";

    export let message: string;
    export let title: string;
    export let ok: string = 'ACEPTAR';
    export let cancel: string = 'CANCELAR';
    const {close} = getContext("simple-modal");
    export let onAccept = () => {
    };
    export let onCancel = () => {
    };
    const onOk = () => {
        onAccept();
        close();
    }
    const onClose = () => {
        onCancel();
        close();
    }
</script>
<div>
    {#if title}
        <h2 class="text-c mt-1">{title}</h2>
    {/if}
    <div contenteditable="true"
         class="text-c my-2"
         bind:innerHTML={message}>
    </div>
    <div class="box-r sx-1">
        <div class="action" on:click={onOk}>
            {ok}
        </div>
        <div class="action" on:click={onClose}>
            {cancel}
        </div>
    </div>
</div>

<style>
    .action {
        color: var(--accent);
        font-weight: 900;
        cursor: pointer;
    }
</style>
